module.exports = __webpack_public_path__ + "img/charity-3.5dcaf3b6.png";